import '@splidejs/splide/css/core';
import Splide from '@splidejs/splide';

const initializeBlock = function ($block) {
  
  // For backend, ensure we're targeting the actual block.
  if (!!$block[0]) {
    $block = $block[0];
  }

  // Default Slider Block
  if (!!$block.querySelector(".custom-grid-carousel")) {
    var slider = $block.querySelector(".custom-grid-carousel");

    if( slider ) {
      var splide = new Splide( '.custom-grid-carousel' , {
        type: 'fade',
        interval: 4000, // duration between
        speed: 4000, // transition
        arrows: false,
        pagination: false,
        autoplay: true,
        rewind: true
      });
      splide.mount();
    }

  }

  
};

// Initialize the slider on the front end
export const initializeImageCarousel = function() {
  window.addEventListener("load", function () {
    var sliders = document.querySelectorAll(".custom-grid");
    Array.prototype.forEach.call(sliders, function (el, i) {
      initializeBlock(el);
    });
  });
}

export const initializeImageCarouselEditor = function() {
  // Initialize dynamic block preview (editor).
  if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=custom-grid', initializeBlock );
  }
}